import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import {  FaGithub, FaLinkedin } from "react-icons/fa";
import { FiMail } from "react-icons/fi"
import logo from "./common/logo.jpeg"



import "../App.css"

const links = [
    {
        title: "Home",
        path: "/",
    },
    {
        title: "About",
        path: "/about",
    },
    {
        title: "Projects",
        path: "/projects",
    },
    {
        title: "Service",
        path: "/service",
    },
    {
        title: "Blog",
        path: "/blog",
    },
    {
        title: "Contact",
        path: "/contact",
    },
];

function Header() {


    const [displaySidenav, setDisplaySidenav] = useState(false);

    const handleClick = (e) => {
        e.preventDefault();
        setDisplaySidenav(!displaySidenav);
    };

    return (
        <>
            <header className="app-header app-header-1">
                <div className="header-logo">
                    <Link to="/"><img src={logo} alt="My Logo" width="50" height="50"/></Link>
                </div>
                <button className="button button-menu" onClick={(e) => handleClick(e)}>
                    <span></span>
                </button>
                <ul className="header-dots">
                    {links.map((item, index) => (
                        <li key={index}>
                            <NavLink to={`${item.path}`} activeClassName="active">
                                <span className="circle"></span>
                            </NavLink>
                        </li>
                    ))}
                </ul>
                <ul className="header-menu">
                    {links.map((item, index) => (
                        <li key={index}>
                            <NavLink to={`${item.path}`} activeClassName="active">
                                <span className="anchor">{item.title}</span>
                            </NavLink>
                        </li>
                    ))}
                </ul>
                <div className="header-follow">
                    <ul>
                        <li>
                            <a href="mailto:esracebi.81@gmail.com" target="_blank"  title="mail to" >
                            <FiMail className="icon" color="white" />
                            </a>
                        </li>
                        <li>
                            <a href="https://github.com/EsraHaytaoglu" target="_blank" >
                            <FaGithub color="white" />
                            </a>
                        </li>
                        <li>
                            <a href="https://www.linkedin.com/in/esrahaytaoglu/" target="_blank" >
                                <FaLinkedin />
                            </a>
                        </li>
                    </ul>
                    <p>Follow Me</p>
                </div>
            </header>
            <div className={`app-sidenav ${displaySidenav && "active"}`}>
                <div className="sidenav-menu">
                    <div className="logo">
                        <Link to="/"><img src={logo} alt="My Logo" width="50" height="50"/> </Link>
                    </div>
                    <button className="button" onClick={(e) => handleClick(e)}></button>
                    <ul className="sidenav-nav">
                        {links.map((item, index) => (
                            <li key={index} onClick={(e) => handleClick(e)}>
                                <NavLink to={`${item.path}`} activeClassName="active">
                                    <span className="anchor">{item.title}</span>
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                    <div className="sidenav-links">
                        <ul>
                            <li>
                            <a href="mailto:esracebi.81@gmail.com" target="_blank"  title="mail to" >
                                    <FiMail className="icon" />
                                </a>
                            </li>
                            <li>
                            <a href="https://github.com/EsraHaytaoglu" target="_blank" >
                                    <FaGithub className="icon" />
                                </a>
                            </li>
                            <li>
                            <a href="https://www.linkedin.com/in/esrahaytaoglu/" target="_blank" >
                                    <FaLinkedin className="icon" />
                                </a>
                            </li>
                        </ul>
                        <p>Follow Me</p>
                    </div>
                </div>
                <span className="sidenav-close" />
            </div>
            
        </>
    );
}

export default Header;
